/**
 * Updates buy button price/compare from the selected quantity-break offer.
 * Loaded from buy-buttons when "Display price inside the button" is enabled.
 */
(function () {
  'use strict';

  function parseMoneyToNumber(str) {
    if (!str) return 0;
    var s = String(str).trim();
    if (!s || /\{\{/.test(s)) return 0;

    s = s.replace(/[^\d.,-]/g, '');
    if (!s) return 0;

    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');

    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      s = s.replace(/,/g, '');
    } else if (lastComma >= 0) {
      var afterComma = s.length - lastComma - 1;
      s = afterComma <= 2 ? s.replace(',', '.') : s.replace(/,/g, '');
    }

    var n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }

  function isSubscriptionActive() {
    var autoRefill = document.getElementById('auto_refill');
    if (autoRefill) return !!autoRefill.checked;

    var subscribeInput = document.querySelector('.subscribe-input');
    var onetimeInput = document.querySelector('.onetime-input');
    if (subscribeInput && onetimeInput) {
      return !!subscribeInput.checked;
    }
    if (subscribeInput) {
      return !!subscribeInput.checked;
    }

    return true;
  }

  function isSubscriptionToggle(el) {
    if (!el) return false;
    if (el.id === 'auto_refill') return true;
    if (el.classList && (el.classList.contains('subscribe-input') || el.classList.contains('onetime-input'))) {
      return true;
    }
    if (el.closest && el.closest('.auto-refill') && el.type === 'checkbox') return true;
    return false;
  }

  function getSelectedQuantityRadio() {
    return document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
  }

  function labelForQuantityRadio(radio) {
    var label = radio.nextElementSibling;
    if (label && label.tagName === 'LABEL' && radio.id && label.getAttribute('for') === radio.id) {
      return label;
    }
    if (radio.id) {
      var byFor = document.querySelector('label[for="' + radio.id + '"]');
      if (byFor) return byFor;
    }
    return null;
  }

  function priceElInLabel(label) {
    return label.querySelector('.quantity-break__right .quantity-break__price') || label.querySelector('.quantity-break__price');
  }

  function compareElInLabel(label) {
    return label.querySelector('.quantity-break__right .quantity-break__compare-price') || label.querySelector('.quantity-break__compare-price');
  }

  function readPriceText(el) {
    if (!el) return '';
    var span = el.querySelector('.qb-dynamic-sp-price-value') || el.querySelector('span');
    return String(span ? span.textContent : el.textContent || '').trim();
  }

  function updateBuyButtonPrice() {
    document.querySelectorAll('[data-main-atc-button-price]').forEach(function (wrap) {
      var compareEl = wrap.querySelector('[data-main-atc-compare-price]');
      var priceEl = wrap.querySelector('[data-main-atc-price]');
      if (!priceEl) return;

      var radio = getSelectedQuantityRadio();
      var sub = isSubscriptionActive();
      var activePrice = '';
      var comparePrice = '';

      if (radio) {
        var subPrice = radio.getAttribute('data-price-subscription');
        var onePrice = radio.getAttribute('data-price-onetime');
        var compareSub = radio.getAttribute('data-compare-subscription');

        if (subPrice || onePrice) {
          activePrice = sub ? (subPrice || onePrice || '') : (onePrice || subPrice || '');

          if (sub && compareSub && parseMoneyToNumber(compareSub) > parseMoneyToNumber(subPrice || activePrice)) {
            comparePrice = compareSub;
          }
        } else {
          var label = labelForQuantityRadio(radio);
          if (label) {
            var labelPriceEl = priceElInLabel(label);
            var labelCompareEl = compareElInLabel(label);

            if (labelPriceEl) {
              activePrice = readPriceText(labelPriceEl);
            }

            if (labelCompareEl && !labelCompareEl.classList.contains('hidden')) {
              comparePrice = readPriceText(labelCompareEl);
            }
          }

          if (!activePrice) {
            activePrice = String(radio.getAttribute('data-price') || '').trim();
          }
        }
      }

      if (!activePrice) {
        activePrice = String(priceEl.getAttribute('data-fallback-price') || priceEl.textContent || '').trim();
      }

      if (!comparePrice && !radio) {
        comparePrice = String(priceEl.getAttribute('data-fallback-compare') || '').trim();
      }

      // Toothpaste price only — gum upsell A/B totals are not added to the CTA.
      if (activePrice) {
        priceEl.textContent = activePrice;
      }

      if (compareEl) {
        if (comparePrice && parseMoneyToNumber(comparePrice) > parseMoneyToNumber(activePrice)) {
          compareEl.textContent = comparePrice;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hidden');
        }
      }
    });
  }

  function scheduleUpdate() {
    updateBuyButtonPrice();
    setTimeout(updateBuyButtonPrice, 0);
    setTimeout(updateBuyButtonPrice, 100);
    setTimeout(updateBuyButtonPrice, 300);
  }

  function init() {
    if (!document.querySelector('[data-main-atc-button-price]')) return;

    scheduleUpdate();

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;

      if (isSubscriptionToggle(e.target) || e.target.matches('.quantity-breaks-container input[name="quantity"]')) {
        scheduleUpdate();
      }
    }, true);

    document.addEventListener('qb:prices-updated', scheduleUpdate);

    document.querySelectorAll('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]').forEach(function (el) {
      el.addEventListener('change', scheduleUpdate);
      el.addEventListener('input', scheduleUpdate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 0);
    });
  } else {
    setTimeout(init, 0);
  }
})();
